import React from 'react';
import s from './Loader.module.css';

import IconLoadingSpinner from '../icons/emodji/IconLoadingSpinner';
const Loader: React.FC<{ text?: string; blur?: boolean }> = ({ text, blur }) => {
    return (
        <div className={`${s.loading} ${blur ? s.blur : ''}`}>
            <div className={s.loading_spinner}>
                <IconLoadingSpinner width={20} height={20} />
            </div>
            <p className={s.text}>{text}</p>
        </div>
    );
};

export default Loader;
